/* global visualSwings, data, serverParams */
import React from 'react'
import { render } from 'react-dom'
import type Swing from './types/Swing.ts'

import App from './App.tsx'
import { SwingPathData } from './types/globals.ts'

const swingPathData = data as SwingPathData[]

function idFunction(
    playerId: number | string,
    year: number | string,
    batSide: string
) {
    return `${playerId}-${year}-${batSide}`
}

function sortOrder(a: Swing, b: Swing) {
    if (a.name !== b.name) {
        return a.name > b.name ? 1 : -1
    }

    return a.year > b.year ? -1 : 1
}

const $app = document.getElementById('app')

const swings: Swing[] = visualSwings
    .map((p) => ({
        ...p,
        lastName: p.name.split(',')[0],
        id: idFunction(p.playerId, p.year, p.batSide),
    }))
    .sort(sortOrder)

const seasons = [serverParams.seasonEnd]

let i = serverParams.seasonEnd
while (i > serverParams.seasonStart) {
    i -= 1
    seasons.push(i)
}

const possibleArr = swingPathData.flatMap((row) => {
    const sides = Number(row.n_sides) === 2 ? ['L', 'R'] : [row.side]
    const ids = seasons
        .map((season) =>
            sides.map((side) => idFunction(row.savant_batter_id, season, side))
        )
        .flat()

    return ids
})

const possibleIds = new Set(possibleArr)

const relevantSwings = visualSwings
    .filter((d) => {
        const id = idFunction(d.playerId, d.year, d.batSide)
        return possibleIds.has(id)
    })
    .map((p) => ({
        ...p,
        lastName: p.name.split(',')[0],
        id: idFunction(p.playerId, p.year, p.batSide),
    }))
    .sort(sortOrder)

const relevantIds = new Set(relevantSwings.map((d) => d.id))

if ($app) {
    const url = new URL(window.location.href)
    const playerListStr = url.searchParams.get('playerList')
    const selectedIdxStr = url.searchParams.get('selectedIdx')

    let playerList: Swing[] = []
    let selectedIdx = 0

    if (playerListStr) {
        const swingIds = playerListStr.split(',')
        playerList = swings.filter((d) => swingIds.includes(d.id))
    }

    if (!playerList.length) {
        const swingId = possibleArr.find((d) => relevantIds.has(d))

        if (swingId) {
            const swing = swings.find((d) => d.id === swingId)
            if (swing) {
                playerList = [swing]
            }
        }

        const JULIO = 677594
        const SHOHEI = 660271
        const CAMINERO = 691406

        const topOptions = new Set([JULIO, SHOHEI, CAMINERO])
        const { seasonEnd } = serverParams

        if (!playerList.length) {
            switch (seasonEnd) {
                case 2023:
                    // Julio
                    playerList = swings.filter((d) => d.id === '677594-2023-R')
                    break
                case 2024:
                    // Julio
                    playerList = swings.filter((d) => d.id === '677594-2024-R')
                    break
                case 2025:
                    // Ohtani
                    playerList = swings.filter((d) => d.id === '660271-2025-L')
                    break
                case 2026:
                    // Caminero
                    playerList = swings.filter((d) => d.id === '691406-2026-R')
                    break
                default: {
                    const player = swings.find(
                        (d) =>
                            topOptions.has(d.playerId) && d.year === seasonEnd
                    )
                    const yearSwings = swings.filter(
                        (d) => d.year === seasonEnd
                    )
                    if (player) {
                        playerList = [player]
                    } else {
                        // all else fails go random
                        const haystack = yearSwings.length ? yearSwings : swings
                        const randomIdx = Math.floor(
                            Math.random() * haystack.length
                        )
                        playerList = [haystack[randomIdx]]
                    }
                }
            }
        }
    }

    if (selectedIdxStr && Number(selectedIdxStr)) {
        selectedIdx = Number(selectedIdxStr)
    }
    render(
        <App
            swings={swings}
            relevantSwings={relevantSwings}
            initPlayerList={playerList}
            initSelectedIdx={selectedIdx}
        />,
        $app
    )
}
